// Tiny DOM-binding helpers shared by App and the screen modules. Both look up
// elements by id after the screen's markup has been injected into #app.

/** Attach an event listener to the element with the given id, if it exists. */
export function bind(id: string, ev: string, fn: EventListenerOrEventListenerObject): void {
  document.getElementById(id)?.addEventListener(ev, fn);
}

// For elements that look like buttons but aren't (clickable <div>s carrying
// role="button"): wire click AND Enter/Space so keyboard users can operate
// them too. Native <button>s are already covered by bind() + the browser.
export function bindActivate(id: string, fn: () => void): void {
  const el = document.getElementById(id);
  if (!el) return;
  el.addEventListener("click", fn);
  el.addEventListener("keydown", (e) => {
    const key = (e as KeyboardEvent).key;
    if (key === "Enter" || key === " ") {
      e.preventDefault();
      fn();
    }
  });
}
